import React from 'react';
import { useAppSelector, configSelectors, useAppDispatch, configActions, } from '@pomofocus/shared-client';
import Selections from '../../common/Selections';
import { WEEK_START_SELECTION } from '../../../constants';
import { IconSets } from '../../common/IconSets';
import { FormBlock, FlexWrapper, FormHeader, FormHeaderText, SectionWrapper, } from './common';
export function ReportConfig() {
    const dispatch = useAppDispatch();
    const configObj = useAppSelector(configSelectors.selectConfigObj);
    function handleSelectWeekStart(weekStartId) {
        dispatch(configActions.updateConfigObj({
            ...configObj,
            weekStart: weekStartId,
        }));
    }
    return (React.createElement(SectionWrapper, { subHeader: "Report", SubHeaderIcon: React.createElement(IconSets, { name: "BarGraph" }) },
        React.createElement(FormBlock, null,
            React.createElement(FlexWrapper, null,
                React.createElement(FormHeader, null,
                    React.createElement(FormHeaderText, null, "Start of the week")),
                React.createElement(Selections, { selectedId: configObj.weekStart, handleSelect: handleSelectWeekStart, selection: WEEK_START_SELECTION, idAttr: "id", textAttr: "text", width: 110, fontSize: 14 })))));
}
